export const getModalsState = (state) => state.modals;
